<template>
  <Form
    :error="error"
    :error-text="error"
    class="form-block-popup"
    @submit="submit"
  >
    <div class="top-window between between-center">
      <div class="heading1 heading1-line">Одобрение заявки</div>
    </div>

    <div class="_2-fields">
      <div class="formcell formcell-mb0">
        <label class="label">
          Выберите сотрудника <span class="required">*</span>
        </label>
        <div class="drop w-dropdown select-person">
          <div class="droptoggle droptoggle-input w-dropdown-toggle">
            <input
              v-model="search"
              type="text"
              class="input w-input"
              maxlength="256"
              placeholder="Начните вводить имя сотрудника"
              @focus="usersOpen = true"
              @blur="usersOpen = false"
            >
          </div>
          <nav :class="{'w--open': usersOpen}" class="select-list w-dropdown-list">
            <div
              v-for="user in employees.filter(user => user.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || user.email.toLowerCase().indexOf(search.toLowerCase()) > -1)"
              :key="user.id"
              :class="{current: employee === user.id}"
              class="select-item w-inline-block"
              @mousedown="change(user.id)"
            >
              <div>{{ user.name || user.email }}</div>
              <div v-if="employee === user.id" class="icon-20px">
                <CheckBlueIcon />
              </div>
            </div>
          </nav>
        </div>
        <div class="text-secondary ts-mt8">
          Добавить сотрудника можно в <span class="link" @click="openSettings">настройках</span>
        </div>
      </div>
      <div class="formcell formcell-mb0">
        <label class="label">Укажите дату готовности <span class="required">*</span></label>
        <div class="drop w-dropdown" tabindex="0" @blur="pickerOpen = false">
          <div @click="pickerOpen = true" class="droptoggle w-dropdown-toggle">
            <div>{{ datePrint }}</div>
          </div>
          <DatePicker :class="{'w--open': pickerOpen}" :is-range="false" @pick="d => date = d" />
        </div>
      </div>
    </div>

    <Submit
      :loading="isLoading"
      usual
      small
      text="Принять заказ"
    />
  </Form>
</template>

<script>
  import Form from '@/components/Form';
  import Submit from '@/components/Submit';
  import InviteEmployee from '@/containers/header/InviteEmployee';
  import {mapActions} from 'vuex';
  import CheckBlueIcon from '@/icons/check-blue.svg';
  import DatePicker from '@/components/DatePicker';
  import formatDate from '@/utils/formatting/format-date';
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/api/parse-error';

  export default {
    name: 'EndOrder',
    components: {
      DatePicker,
      Submit,
      Form,
      CheckBlueIcon,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          id: null,
        }),
      },
    },
    data () {
      return {
        isLoading: false,
        error: null,
        employees: [],
        search: '',
        employee: null,
        date: '',
        usersOpen: false,
        pickerOpen: false,
      };
    },
    computed: {
      datePrint () {
        return this.date ? formatDate(this.date) : 'Выберите дату';
      },
    },
    created() {
      this.load();
    },
    methods: {
      ...mapActions({
        close: 'modal/closeModal',
        openModal: 'modal/openModal',
        reload: 'global/changeAction',
      }),
      change (id) {
        this.employee = id;
        const employee = this.employees.find(user => user.id === id) || {};
        this.search = employee.name || employee.email || '';
        this.usersOpen = false;
      },
      async submit () {
        this.error = null;

        if (!this.employee || !this.date) {
          if (!this.employee && !this.date) this.error = 'Выберите сотрудника и дату завершения заказа.';
          else if (!this.employee) this.error = 'Выберите сотрудника из списка.';
          else if (!this.date) this.error = 'Выберите дату завершения заказа.';
          return;
        }

        try {
          this.isLoading = true;
          await factory(`laboratory/orders/${this.context.id}/appoint`).customPost({
            responsible_id: this.employee,
            deadline: this.date,
          });
          await this.reload('reloadOrders');
          this.reload();
          this.close();
          this.isLoading = false;
        } catch (e) {
          this.error = parseError(e) || 'Что-то пошло не так.';
          this.isLoading = false;
        }
      },
      async load () {
        this.error = null;
        try {
          this.isLoading = true;
          const {data} = await factory('laboratory').indexInPath('employees');
          this.employees = data?.filter(person => person.is_active);
          this.isLoading = false;
        } catch (e) {
          this.error = 'Не удалось загрузить сотрудников. Попробуйте перезагрузить страницу.';
          this.isLoading = false;
        }
      },
      openSettings () {
        this.openModal({
          component: InviteEmployee,
          context: {
            attributes: {
              windowClass: 'window-fixed',
              class: 'popup-team',
            },
          },
        });
      },
    },
  };
</script>

<style lang="scss">
  .popup-work {
    .input{
      border: none;
    }

    .drop.select-person {
      z-index: 1000;
    }

    .btn-wrap {
      float: unset;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      input[type=submit] {
        width: 200px;
      }
      @media screen and (max-width: 480px) {
        input[type=submit] {
          width: 100%;
        }
      }
    }

    // To Work Embeds
    .select-item .icon-20px{
      opacity: 0;
    }

    .select-item.current .icon-20px{
      opacity: 1;
    }

    .select-item.current{
      color: #1BA6DF;
    }
  }
</style>
